var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81.437L7.091.058c-.199-.104-.47-.064-.604.089L2.971 4.179 1.354 2.922a.526.526 0 00-.613 0L.127 3.4c-.17.13-.17.345 0 .477L2.613 5.81A.97.97 0 003.168 6a.722.722 0 00.523-.24L7.925.904C8.06.752 8.008.542 7.81.437z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiANCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggZD0iTTcuODA5NDcgMC40MzczMzNMNy4wOTE4NCAwLjA1ODIyNTlDNi44OTMyOCAtMC4wNDYyNzE3IDYuNjIxMjQgLTAuMDA2MTczNiA2LjQ4ODM1IDAuMTQ2OTI3TDIuOTcwNTcgNC4xNzg1OUwxLjM1Mzk1IDIuOTIyMTlDMS4xODUxIDIuNzkwOTYgMC45MDk5MzIgMi43OTA5NiAwLjc0MTA3OSAyLjkyMjE5TDAuMTI2NjQgMy4zOTk3MUMtMC4wNDIyMTMzIDMuNTMwOTQgLTAuMDQyMjEzMyAzLjc0NDggMC4xMjY2NCAzLjg3NzI0TDIuNjEyNTQgNS44MDkyM0MyLjc1MTY4IDUuOTE3MzcgMi45NzA1NyA2IDMuMTY3NTYgNkMzLjM2NDU2IDYgMy41NjMxMiA1LjkwNDAxIDMuNjkxMzIgNS43NTk0MUw3LjkyNTE2IDAuOTA1MTQxQzguMDU5NjIgMC43NTIwNDEgOC4wMDgwMyAwLjU0MTgzIDcuODA5NDcgMC40MzczMzNaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9zdmc+DQo=";
export { SvgCheck as ReactComponent };